import {
    NavLink
  } from "react-router-dom";

import {ReactComponent as Logo } from '../img/logo.svg';

// si hay error de autentificación
import { Login } from "../components/Login";

import Navigation from '../components/Navigation';

// export async function loader() {
//   const pacientes = await API.getAllPacientes();
//   return { pacientes };
// }

export function LoginPage() {
  const isAuthenticated = !!sessionStorage.getItem("token");
  return (
    <>
      
      <div id="sidebar">
      {/* <Login /> */}
        <div className="logo"><Logo /></div>
        
        {/* other code */}


        {/* other code */}
      </div>
      { isAuthenticated ? (
      <main id="main">
        <Navigation />
        <div id="detail">
          <Login />
        </div>
      </main>
      ) : (
      <main id="main">
        <div id="detail">
          <Login />
        </div>
      </main>
      ) }
    </>
  );
}